import React from 'react';
import classnames from 'classnames';
import {getSelectedOptionLabel} from '../../../utils/options';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import styles from './styles.module.scss';
import {buildingTypeIdOptions} from "../../../../../common/constants/options";

export const Page6TextContentItem1 = React.forwardRef(({className}, ref) => {
  return (
    <div className={classnames(styles.itemTitle, styles.sectionPadding, className)} ref={ref}>
      בניין ראשי
    </div>
  );
});

export const Page6TextContentItem2 = React.forwardRef(({className}, ref) => {
  const {
    data: {
      pdfData: {
        buildingJointHome,
        helka,
        gush,
        buildingTypeId
      }
    }
  } = useCompleteInspectionContext();
  const buildingJointHomeValue = (buildingJointHome === 1) ? 'הרשום כבית משותף' : '';
  const buildingTypeValue = getSelectedOptionLabel(buildingTypeId, buildingTypeIdOptions);

  return (
    <div className={classnames(styles.itemText, styles.innerPadding, className)} ref={ref}>
      {[
        'על חלקה',
        helka,
        'בגוש',
        gush,
        'בנוי',
        buildingTypeValue,
        `${buildingJointHomeValue}.`,
        'להלן יובא תיאורו:'
      ].filter(Boolean).join(' ')}
    </div>
  );
});

export default [
  Page6TextContentItem1,
  Page6TextContentItem2,
];
